<template>
  <el-dialog
    :close-on-click-modal="false"
    custom-class="question-review-msg-box"
    :title="title"
    :visible.sync="visible"
    @keyup.enter.native="onSubmit()">
    <error-message-list
      v-if="!message"
      v-model="errorMsg"
      :messages="messages"/>
    <el-input
      :autosize="{ minRows: 1}"
      type="textarea"
      placeholder="请输入不通过原因"
      v-model="errorMsg"
      resize="none"
      :disabled="!!message">
    </el-input>
    <p style="padding-top: 10px;"
       v-if="components.prolongTime">
      <el-checkbox v-model="prolongTimeEnabled"
                   style="margin-right: 10px;">允许工单可修改时间至月日时分秒
      </el-checkbox>
      <el-date-picker
        size="mini"
        :disabled="!prolongTimeEnabled"
        value-format="yyyy-MM-dd HH:mm:ss"
        v-model="prolongTime"
        type="datetime"
        placeholder="选择日期时间"
        align="center"
        style="width: 180px;">
      </el-date-picker>
    <div slot="footer"
         class="dialog-footer">
      <el-button @click="$emit('update:visible', false)">取消</el-button>
      <el-button type="danger"
                 :disabled="!errorMsg"
                 @click="onSubmit()">确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import moment from 'moment'
import ErrorMessageList from './ErrorMessageList'

export default {
  mixins: [],
  components: {ErrorMessageList},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    callback: {
      type: Function,
      default: Function.prototype,
    },
    components: {
      type: Object,
      default: {},
    },
    title: String,
    message: String,
    messages: {
      type: Array,
      default () {
        return []
      },
    },
    defaultProlongTime: String,
  },
  data () {
    return {
      errorMsg: '',
      prolongTimeEnabled: false,
      prolongTime: null,
    }
  },
  computed: {},
  watch: {
    visible (val) {
      if (val === false) {
        Object.assign(this.$data, this.$options.data())
      } else {
        this.prolongTime = this.defaultProlongTime
        this.errorMsg = this.message
      }
    },
    message (val) {
      this.errorMsg = val
    },
  },
  created () {},
  mounted () {},
  destroyed () {},
  methods: {
    onSubmit () {
      let callbackData = {
        message: this.errorMsg,
      }
      // 验证订单可修改时间
      if (this.prolongTimeEnabled) {
        if (!this.prolongTime) {
          return this.$alert('请填写订单可修改时间', '提示', {type: 'error'})
        }
        if (moment().isAfter(this.prolongTime)) {
          return this.$alert('订单可修改时间应在此刻之后', '提示', {type: 'error'})
        }
        callbackData.prolongTime = this.prolongTime
      }
      this.$emit('update:visible', false)
      this.callback(callbackData)
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss"
       scoped>
</style>



// WEBPACK FOOTER //
// src/views/question-review/components/ReviewBox/src/OrderBack.vue